export default "__VITE_ASSET__feb4088f__"